function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 20.25,
  cy: 20,
  r: 18,
  fill: "#FFF799"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.7501 11.1172H22.9001C22.9001 11.1172 26.9576 11.1172 26.9576 13.9897C26.9576 13.9897 27.4001 17.2372 23.0201 17.2372H16.1276C16.1276 17.2372 11.5601 16.8622 11.5601 21.6772C11.5601 21.6772 11.5601 26.3647 17.6876 26.3647H23.5001M23.5001 24.4072C23.5203 25.2151 23.7545 26.0031 24.1787 26.6909C24.603 27.3787 25.2022 27.9416 25.9151 28.3222C25.9151 28.3222 28.3376 26.9197 28.3376 24.4072C28.3376 23.7647 28.0823 23.1485 27.628 22.6942C27.1737 22.2399 26.5575 21.9847 25.9151 21.9847C25.2726 21.9847 24.6564 22.2399 24.2021 22.6942C23.7478 23.1485 23.4926 23.7647 23.4926 24.4072",
  stroke: "#BB001E",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgStepCurrentWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepCurrentWarning);
export default __webpack_public_path__ + "static/media/step-current-warning.d6c665c5.svg";
export { ForwardRef as ReactComponent };